import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';
import { encodeColor } from '../tgccRequest';



const container: React.CSSProperties = {
    backgroundColor:'#3A54B4',
    height:'462px',
    display:'flex'
}
const text: React.CSSProperties = {
    color:'#040A5E',
    fontSize:'18px',
    width:'75%'
}
const getBtn: React.CSSProperties = {
    borderRadius:'20px',
    width:'268px',
    height:'42px',
    display:'flex',
    justifyContent:'center',
    padding:'10px',
    marginTop:'15%',
    cursor:'pointer',
    alignItems:'center',
    color:'white',
    border:'none',
    backgroundColor:'#040A5E',
    ':hover':{
        border:'1px solid #040A5E',
        color:'#040A5E',
        backgroundColor:'white' 
}
}
const stepDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    marginTop:'150px',
    marginLeft:'15px'
}
const how: React.CSSProperties = {
    fontSize:'40px',
    fontFamily:'Lulo',
    color:'white',
    marginBottom:'25px'
}
const stepImg: React.CSSProperties = {
    height:'135px'
}
const howDiv: React.CSSProperties = {
    width:'40%',
    marginLeft:'12%',
    marginTop:'85px'
}

class _WhyUs extends React.Component<Tgcc.BaseProps, any> {  
openHowItWorks = () =>{browserHistory.push(Tgcc.Routes.CampusHowItWorks)}
    render() {      
        return (
                <div style={container} className="howCont">
                    <div style={howDiv} className="howInCont">
                        <div style={how} className="howTxt">HOW IT WORKS</div>
                        <div style={text} className="howPara">We believe that custom apparel SHOULD be made simple, fast, and fun. Let us walk you through our proof request, designing, and ordering processes to show you just how easy custom apparel can be!</div>
                        <div style={getBtn} onClick={this.openHowItWorks} className="howBtn">How to Get Started</div>
                    </div>
                    <div style={stepDiv} className="stepDiv">
                        <img style={stepImg} src={Tgcc.ResolveUrl('~/images/Step-1.png')} />
                        <img style={stepImg}src={Tgcc.ResolveUrl('~/images/Step-2.png')} />
                        <img style={stepImg}src={Tgcc.ResolveUrl('~/images/Step-3.png')} />
                    </div>
                </div>   
        )
    }
}
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var WhyUs = connect(mapStateToProps)(Radium(_WhyUs));
